import {
  Avatar,
  Box,
  List,
  ListItemButton,
  Stack,
  Typography,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { BusinessCenterRounded } from "@mui/icons-material";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import JobItemLoadingSkeleton from "../loadingSkeletons/LoadingList";

const Sourcesjobslist = ({ jobs = [], loading, hasMore, onLoadMore, onSelectJob, selectedJob }) => {
  const theme = useTheme();

  const isDesktopLarge = useMediaQuery("(min-width: 1920px)");
  const isDesktopMedium = useMediaQuery("(min-width: 1440px) and (max-width: 1919px)");
  const isDesktopSmall = useMediaQuery("(min-width: 1200px) and (max-width: 1439px)");
  const isDesktopXS = useMediaQuery("(min-width: 992px) and (max-width: 1199px)");

  const getTimeAgo = (timestamp) => {
    if (!timestamp) return "";
    const lastModifiedMoment = moment(timestamp);
    const now = moment();
    const diffInSeconds = now.diff(lastModifiedMoment, "seconds");
    return diffInSeconds < 60 ? "a few seconds ago" : lastModifiedMoment.fromNow();
  };

  const itemsScroll = [1, 2, 3, 4]; // skeleton placeholders

  return (
    <List sx={{ padding: 0, m: 0 }}>
      {loading && jobs?.length === 0 ? (
        itemsScroll.map((_, idx) => <JobItemLoadingSkeleton key={idx} />)
      ) : (
        <InfiniteScroll
          dataLength={jobs?.length || 0}
          next={onLoadMore}
          hasMore={hasMore}
          scrollableTarget="sources-jobs-scroll"
          className="infinityscroll"
          style={{ overflow: "visible" }}
          pullDownToRefreshThreshold={50}
        >
          {jobs?.length > 0 ? (
            jobs.map((job, index) => (
              <ListItemButton
                key={index}
                selected={String(selectedJob?.id) === String(job?.id)}
                onClick={() => {
                  if (String(selectedJob?.id) === String(job?.id)) return;
                  onSelectJob(job);
                }}
                sx={{
                  ".hide-icons": { display: "none" },
                  "&:hover": { ".hide-icons": { display: "block" } },
                  padding: isDesktopLarge
                    ? "10px 20px"
                    : isDesktopMedium
                      ? "8px 16px"
                      : isDesktopSmall
                        ? "6px 12px"
                        : "6px 12px",
                }}
              >
                <div style={{ display: "flex", gap: 10, width: "100%" }}>
                  <Avatar
                    sx={{
                      height: isDesktopLarge
                        ? "40px"
                        : isDesktopMedium
                          ? "35px"
                          : isDesktopSmall
                            ? "32px"
                            : "28px",
                      width: isDesktopLarge
                        ? "40px"
                        : isDesktopMedium
                          ? "35px"
                          : isDesktopSmall
                            ? "32px"
                            : "28px",
                    }}
                  >
                    <BusinessCenterRounded
                      sx={{
                        color: "#fff",
                        height: isDesktopLarge
                          ? "24px"
                          : isDesktopMedium
                            ? "20px"
                            : isDesktopSmall
                              ? "16px"
                              : "14px",
                        width: isDesktopLarge
                          ? "24px"
                          : isDesktopMedium
                            ? "22px"
                            : isDesktopSmall
                              ? "18px"
                              : "16px",
                      }}
                    />
                  </Avatar>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Stack direction="column">
                      <Typography
                        sx={{
                          fontSize: isDesktopXS ? "10px" : "12px",
                          fontWeight: 600,
                          margin: 0,
                          display: "-webkit-box",
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          flex: 1,
                          minWidth: 0,
                          wordBreak: "break-word",
                        }}
                      >
                        {job?.jobtitle}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: isDesktopXS ? "8px" : "10px",
                          fontWeight: 500,
                          margin: 0,
                          display: "-webkit-box",
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          flex: 1,
                          minWidth: 0,
                          wordBreak: "break-word",
                        }}
                      >
                        {job?.company_name}
                      </Typography>
                      <Box sx={{ width: "200px" }}>
                        <Box sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%",
                          gap: 1 // Adds consistent spacing
                        }}>
                          <Typography sx={{
                            fontSize: isDesktopXS ? "8px" : "10px",
                            margin: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}>
                            {job?.location || "Remote"}
                          </Typography>
                          <Typography
                            sx={{
                              margin: 0,
                              color: "#757575",
                              fontWeight: 500,
                              fontSize: isDesktopLarge ? "0.65rem" : "0.60rem",
                              whiteSpace: "nowrap",
                              flexShrink: 0 // Prevents the date from shrinking
                            }}
                          >
                            {getTimeAgo(job?.posted_date)}
                          </Typography>
                        </Box>
                      </Box>
                    </Stack>
                  </Box>
                </div>
              </ListItemButton>
            ))
          ) : (
            !loading && (
              <Card>
                <CardContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 4 }}>
                  <Typography variant="body2" component="h2" gutterBottom>
                    No Jobs Found
                  </Typography>
                </CardContent>
              </Card>
            )
          )}

          {/* skeletons for "load more" state */}
          {loading && jobs?.length > 0 && itemsScroll.map((_, idx) => <JobItemLoadingSkeleton key={idx} />)}
        </InfiniteScroll>
      )}
    </List>
  );
};

export default React.memo(Sourcesjobslist);
